import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [4, 6];
export const weeks = {
    0: "日",
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
};
const keys = new Array(31).fill(1).map((x, i) => `m${i + 1}`);
export default (data) => {
    keys.forEach(name => {
        data[4][name] = sum([
            data[0][name], data[1][name], data[2][name], data[3][name]
        ]);
        data[6][name] = calculation(data[4][name], data[5][name], 4)
    })
    return data
}

export const columns = (onChange, date, print) => {
    // 获取当月天数
    const days = moment(date).daysInMonth();
    const _date = moment(date).format('YYYY-MM');
    return [
        {
            title: `细分市场`,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                return <TableText data={props} />
            }
        },
        ...new Array(days).fill(1).reduce((a, b, i) => {
            return [
                ...a,
                {
                    title: weeks[moment(`${_date}-${i + 1}`).day()],
                    align: "center",
                    children: [{
                        title: moment(`${_date}-${i + 1}`).format('MM-D'),
                        dataIndex: `m${i + 1}`,
                        key: `m${i + 1}`,
                        align: "center",
                        width: 120,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: index == 6 ? 'percent' : totalIndex.includes(index) ? 'number' : 'inputNumber',
                                name: `m${i + 1}`,
                                onChange,
                                totalIndex,
                            };
                            return (
                                <TableText data={props} />
                            )
                        }
                    }]
                }
            ]
        }, []),
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.7/compute.js